export default "__VITE_PUBLIC_ASSET__58364c20__"